import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["show", "onClose", "className", "media", "previousButtonText", "nextButtonText", "previousButtonCallback", "nextButtonCallback"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Dialog from './Dialog';
import ResponsiveVideo from '../video/ResponsiveVideo';
import ImagePreloader from '../preloader/ImagePreloader';
import Spinner from '../spinner/Spinner';
import baseDialogPropTypes from './baseDialogPropTypes';

// TODO: add keyboard support left/right
var MediaDialog = /*#__PURE__*/function (_Component) {
  _inherits(MediaDialog, _Component);
  var _super = _createSuper(MediaDialog);
  function MediaDialog(props) {
    var _this;
    _classCallCheck(this, MediaDialog);
    _this = _super.call(this, props);
    _this.state = {
      currentMediaIndex: 0
    };
    _this.handlePrevious = _this.handlePrevious.bind(_assertThisInitialized(_this));
    _this.handleNext = _this.handleNext.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MediaDialog, [{
    key: "handlePrevious",
    value: function handlePrevious() {
      var oldIndex = this.state.currentMediaIndex;
      var newIndex = oldIndex === 0 ? this.props.media.length - 1 : oldIndex - 1;
      this.setState(function () {
        return {
          currentMediaIndex: newIndex
        };
      });
      this.props.previousButtonCallback(newIndex);
    }
  }, {
    key: "handleNext",
    value: function handleNext() {
      var oldIndex = this.state.currentMediaIndex;
      var newIndex = oldIndex === this.props.media.length - 1 ? 0 : oldIndex + 1;
      this.setState(function () {
        return {
          currentMediaIndex: newIndex
        };
      });
      this.props.nextButtonCallback(newIndex);
    }
  }, {
    key: "renderFallback",
    value: function renderFallback() {
      return /*#__PURE__*/React.createElement("div", {
        className: 'text-center text-size-h3'
      }, /*#__PURE__*/React.createElement("span", {
        className: "rioglyph rioglyph-missing text-size-200pct text-color-gray"
      }));
    }
  }, {
    key: "renderImage",
    value: function renderImage(mediaData) {
      var _this2 = this;
      var imageClassNames = classNames('img-responsive', mediaData.className && mediaData.className);
      return /*#__PURE__*/React.createElement(ImagePreloader, {
        src: mediaData.src,
        className: imageClassNames
      }, function (_ref) {
        var status = _ref.status,
          image = _ref.image;
        if (status === ImagePreloader.STATUS_LOADED) {
          // When image has been loaded, render the image tag
          return /*#__PURE__*/React.createElement("img", {
            className: 'ani-fade-in',
            key: image.src,
            src: image.src
          });
        }
        if (status === ImagePreloader.STATUS_FAILED) {
          return _this2.renderFallback();
        }
        return /*#__PURE__*/React.createElement(Spinner, {
          isInverse: false
        });
      });
    }
  }, {
    key: "renderVideo",
    value: function renderVideo(mediaData) {
      var videoClassNames = classNames(mediaData.className && mediaData.className);
      return /*#__PURE__*/React.createElement("div", {
        className: "flex-1-0"
      }, /*#__PURE__*/React.createElement(ResponsiveVideo, _extends({}, mediaData, {
        className: videoClassNames
      })));
    }
  }, {
    key: "renderMediaContent",
    value: function renderMediaContent() {
      var mediaData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (mediaData.type === MediaDialog.MEDIA_TYPE_VIDEO) {
        return this.renderVideo(mediaData);
      }

      // image media is default
      return mediaData.src && this.renderImage(mediaData);
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var media = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var currentMediaIndex = arguments.length > 1 ? arguments[1] : undefined;
      var mediaData = media[currentMediaIndex];
      var mediaContentClassNames = classNames('media-content', 'content-center');
      return /*#__PURE__*/React.createElement("div", {
        className: mediaContentClassNames
      }, this.renderMediaContent(mediaData));
    }
  }, {
    key: "renderFooter",
    value: function renderFooter(props) {
      return /*#__PURE__*/React.createElement("div", {
        className: "position-relative clearfix"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-link pull-left",
        onClick: this.handlePrevious
      }, /*#__PURE__*/React.createElement("span", {
        className: "rioglyph rioglyph-chevron-left"
      }), props.previousButtonText), /*#__PURE__*/React.createElement("div", {
        className: "position-absolute top-50pct left-50pct transform translate-centered"
      }, "".concat(this.state.currentMediaIndex + 1, " / ").concat(props.media.length)), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "btn btn-primary btn-link btn-icon-right pull-right",
        onClick: this.handleNext
      }, /*#__PURE__*/React.createElement("span", {
        className: "rioglyph rioglyph-chevron-right"
      }), props.nextButtonText));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        show = _this$props.show,
        onClose = _this$props.onClose,
        className = _this$props.className,
        _this$props$media = _this$props.media,
        media = _this$props$media === void 0 ? [] : _this$props$media,
        previousButtonText = _this$props.previousButtonText,
        nextButtonText = _this$props.nextButtonText,
        previousButtonCallback = _this$props.previousButtonCallback,
        nextButtonCallback = _this$props.nextButtonCallback,
        remainingProps = _objectWithoutProperties(_this$props, _excluded);
      var currentMediaIndex = this.state.currentMediaIndex;
      if (!show) {
        return null;
      }
      var dialogClassName = classNames('media-dialog', className && className);
      var bodyClassNames = classNames('padding-0');
      var mediaTitle = media[currentMediaIndex].title;
      var mediaSubtitle = media[currentMediaIndex].subtitle || null;
      return /*#__PURE__*/React.createElement(Dialog, _extends({}, remainingProps, {
        show: show,
        title: mediaTitle,
        subtitle: mediaSubtitle,
        body: this.renderBody(media, currentMediaIndex),
        footer: media && media.length > 1 ? this.renderFooter(this.props) : '',
        onHide: onClose,
        className: dialogClassName,
        bodyClassName: bodyClassNames
      }));
    }
  }]);
  return MediaDialog;
}(Component);
MediaDialog.MEDIA_TYPE_IMAGE = 'image';
MediaDialog.MEDIA_TYPE_VIDEO = 'video';
MediaDialog.defaultProps = {
  show: false,
  onClose: function onClose() {},
  disableEsc: false,
  useOverflow: false,
  bsSize: Dialog.SIZE_LG,
  media: [],
  previousButtonText: 'Prev',
  previousButtonCallback: function previousButtonCallback() {},
  nextButtonText: 'Next',
  nextButtonCallback: function nextButtonCallback() {}
};
MediaDialog.propTypes = _objectSpread(_objectSpread({}, baseDialogPropTypes), {}, {
  media: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf([MediaDialog.MEDIA_TYPE_IMAGE, MediaDialog.MEDIA_TYPE_VIDEO]).isRequired,
    src: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    aspectRatio: PropTypes.string,
    className: PropTypes.string
  })).isRequired,
  previousButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  previousButtonCallback: PropTypes.func,
  nextButtonText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  nextButtonCallback: PropTypes.func
});
export default MediaDialog;